import React, { useId } from "react";
import { twMerge } from "tailwind-merge";

/** A titled panel; assistive tech reads it as a region named by its title. */
const Card: React.FunctionComponent<{
  title: React.ReactNode;
  /** Sits at the header's right, e.g. a "View all" link. */
  action?: React.ReactNode;
  className?: string;
  /** True while its content is being fetched, refreshes and their retries included; assistive tech reads it as busy. */
  busy?: boolean;
  children: React.ReactNode;
}> = ({ title, action, className, busy, children }) => {
  const titleId = useId();

  return (
    <section
      aria-labelledby={titleId}
      aria-busy={busy}
      className={twMerge(
        "overflow-hidden rounded-lg border border-gray-200 bg-white",
        className,
      )}
    >
      <header className="flex items-center justify-between gap-3 border-b border-gray-200 px-5 py-3.5">
        <h2 id={titleId} className="text-sm font-bold text-primary-3">
          {title}
        </h2>
        {action}
      </header>
      {children}
    </section>
  );
};

export default Card;
